<eca-app-shell>
  <router-outlet></router-outlet>
  @if (spinner$ | async) {
    <div class="fixed-spinner">
      <mat-spinner
        color="primary"
        mode="indeterminate"
        diameter="100"
        strokeWidth="8"
        aria-label="Processing">
      </mat-spinner>
    </div>
  }
</eca-app-shell>
